export default (currentPathname: string, linkLabel: string): boolean => {
  let pathname = currentPathname.slice(1);
  
  if (currentPathname === '/') {
    pathname = 'research';
  };
  
  return pathname === linkLabel.toLowerCase();
};
